import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { TaskService } from '../../../../../core/timeline';
import { User } from '../../../../../core/auth';

@Component({
  selector: 'kt-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent implements OnInit {
  showTaskList = false;
  @Input() category;
  responsible = [];
  @Input() userObjects;
  @Input() groupedByTemplate;
  @Input() groupedByTeam;
  @Input() groupedByTag;
  @Input() groupedByPatient;
  categoryId;
  @Input() categoryName;
  @Input() tempFilteredEntities;
  @Input() filteredView;
  constructor(private taskService: TaskService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.categoryId = this.category.id;
  }

  getFullNameList(user) {
    const res = '';
    if (!user) {
      return res;
    } else {
      const userId: number = +user;
      const u = this.userObjects.find((e) => e.id === userId);
      if (u) {
        return '' + u.userName;
      }
      return res;
    }
  }

  getUser(user) {
    const userId: number = +user;
    const u = this.userObjects.find((e) => e.id === userId);
    if (u) {
      return u;
    }
    return new User();
  }

  filterByUser(user) {
    this.taskService.userIdFilter.next(user);
    this.taskService.refresh();
    this.cdr.detectChanges();
  }
}
